<div
  class="container"
  style="height: calc(100vh - 200px); display: flex; align-items: center"
>
  <div class="row d-flex align-items-center">
    <!-- LEFT SECTION -->
    <div class="col-lg-4 col-md-5 col-12 text-center mb-4 mb-md-0">
      <h6 class="mb-3">{{ authText.no_license_text }}</h6>
      <img
        src="./assets/images/not-licensed.svg"
        class="img-fluid"
        alt="No License"
        style="max-width: 200px"
      />
      <h6 class="mt-3">{{ authText.no_license_caption }}</h6>
      <h6 class="mt-2">{{ authText.contact_admin }}</h6>
    </div>

    <!-- RIGHT SECTION -->
    <div class="col-lg-8 col-md-7 col-12">
      <div class="carousel-box">
        <div
          id="noLicenseCarousel"
          class="carousel slide h-100"
          data-bs-ride="carousel"
        >
          <div class="carousel-inner h-100">
            <div
              class="carousel-item h-100"
              *ngFor="let img of images; let i = index"
              [class.active]="i === 0"
            >
              <img [src]="img" class="carousel-img" alt="Module image" />
            </div>
          </div>

          <!-- CONTROLS -->
          <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#noLicenseCarousel"
            data-bs-slide="prev"
          >
            <i class="fas fa-chevron-left"></i>
          </button>

          <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#noLicenseCarousel"
            data-bs-slide="next"
          >
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
